/* unplugin-vue-components disabled */import script from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"

import "./proto-pagination.vue?vue&type=style&index=0&id=f21c55a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f21c55a4"]])

export default __exports__